<template>
  <DialogLayout
    title="詳細情報"
    :visible.sync="dialogVisible"
    width="40em"
    @open="open"
  >
    <template #form>
      <TakeoffPassengersDataForm
        ref="takeoffPassengersDataForm"
        v-model="takeoffPassengersDataFormModel"
        label-width="10em"
        formMode="edit"
        billingYmMode="search"
        :editDisabledMode="editDisabledMode"
        :autocomplete-airport-code-set="autocompleteAirportCodeSet"
        :autocomplete-customer-code-set="autocompleteCustomerCodeSet"
      />
    </template>
    <template v-if='!editDisabledMode' #footer>
      <EditDialogFooter
        @update="clickUpdate"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import TakeoffPassengersDataForm from '@/components/organisms/dialog/data/TakeoffPassengersDataForm.vue'
import EditDialogFooter from '@/components/organisms/dialog/EditDialogFooter.vue'
import AirportAutocompleteLoader from '@/mixins/AirportAutocompleteLoader.vue'
import CustomerAutocompleteLoader from '@/mixins/CustomerAutocompleteLoader.vue'

export default {
  components: {
    DialogLayout,
    TakeoffPassengersDataForm,
    EditDialogFooter
  },
  mixins: [
    AirportAutocompleteLoader,
    CustomerAutocompleteLoader
  ],
  props: {
    autocompleteCustomerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteAirportCodeSet: {
      type: Array,
      default: () => ([])
    },
    currentRow: {
      type: Object,
      default: () => {
        return {}
      }
    },
    visible: Boolean
  },
  data () {
    return {
      takeoffPassengersDataFormModel: {
        billing_ym: undefined,
        bill_to_code: undefined,
        destination_airport_code: undefined,
        route_code: undefined,
        paid_flights: undefined,
        paid_passengers: undefined,
        paid_cargo_volume: undefined,
        updated_on: undefined
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (visible) {
        this.$emit('update:visible', visible)
      }
    },
    editDisabledMode: {
      get () {
        return parseInt(this.takeoffPassengersDataFormModel.billing_ym) < parseInt(this.getDefaultBillingYm())
      }
    }
  },
  mounted () {
  },
  methods: {
    async clickUpdate () {
      this.$loadingMask.on()
      this.$refs.takeoffPassengersDataForm.validate()
        .then((valid) => {
          return this.$axios.put('/takeoff-passengers-data', this.takeoffPassengersDataFormModel)
        })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.dialogVisible = false
          this.$emit('refresh', this.takeoffPassengersDataFormModel.billing_ym)
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message)
                break
              default:
            }
          }
          this.$loadingMask.off()
        })
    },
    open () {
      const trimItem = ['bill_to_code', 'destination_airport_code']
      this.$nextTick(() => {
        this.$refs.takeoffPassengersDataForm.clearFields()
        Object.keys(this.takeoffPassengersDataFormModel)
          .forEach((x) => {
            if (trimItem.includes(x)) {
              this.currentRow[x] = this.currentRow[x].trimEnd()
            }
            this.$set(this.takeoffPassengersDataFormModel, x, this.currentRow[x])
          })
      })
    }
  }
}
</script>

<style lang="scss">
</style>
